// INITIALIZATION
document.addEventListener('DOMContentLoaded', checkScrollPosition);

// ACTIONS
window.addEventListener('scroll', optimizedScrollHandler, { passive: true });